import {
  FETCH_PAGES_REQUEST,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_ERROR,
} from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_PAGES_REQUEST:
    case FETCH_PAGES_ERROR:
      return state;

    case FETCH_PAGES_SUCCESS:
      return action.payload;

    default:
      break;

  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetch_pages_reducer.js